export const MECHANIC_CLUB = 'club'
export const MECHANIC_EVENT = 'event'
export const MECHANIC_DISCIPLINE_EVENT = 'discipline_event'
export const MECHANIC_MAP_ITEMS = 'map_items'
export const MECHANIC_TOURNAMENT_BIATHLON = 'tournament_biathlon'
export const MECHANIC_TOURNAMENTS = 'tournaments'
